var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h22.667v22.667H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#80959D",
    transform: "translate(-1.333 -4.333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.638 16.014h-1.75V5.667h10.39v10.389h-3.66M4.722 8.972h4.722M7.556 10.861h2.833M12.278 11.806h7.555M13.222 11.806h6.611"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.667,
    cy: 16.056,
    r: 1.889
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.056,
    cy: 16.056,
    r: 1.889
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.222 8.5h4.655l1.956 3.41V17H18.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/vehicle-icon.ae6cc299b1e6e5931a48a135762b3bee.svg";
export { ForwardRef as ReactComponent };